<script>
    import { appName } from "../../stores/AppConfig";
    import { Title } from '@smui/top-app-bar';
</script>

<Title class="left-splitter h-100" style="min-width: 9.5rem;"><div class="fs-14 h-100 valign-center">{$appName}</div></Title>
 
